import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  statusFilter: 'notdone',
  actionItemsList: [],
  toggle: false,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'title',
      label: 'Title',
      aria: 'Title',
      width: '30%',
      sortable: true,
      searchable: true
    },
    {
      field: 'assignedTo',
      label: 'Assigned To',
      aria: 'Assigned To',
      width: '25%',
      sortable: true,
      searchable: true
    },
    {
      field: 'priority',
      label: 'Priority',
      aria: 'Priority',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      label: 'Created',
      aria: 'Created',
      date: true,
      width: '15%',
      sortable: true,
      searchable: true
    },
    {
      field: 'completeByDate',
      label: 'Complete By',
      aria: 'Complete By',
      date: true,
      width: '15%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
